export default __webpack_public_path__ + "learn-more-visual.png";